import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import EntryNavLinks from '../../EntryNavLinks';
import NavLinks from '../../../meet/NavLinks';

import useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';

import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

const useAthleteUserPayments = () => {
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState } = useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();

  const redirectToPurchases = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.ATHLETE_PURCHASES);
    }
    else {
      //Meet Route
      navigate(NavLinks.ATHLETE_PURCHASES);
    }
  };

  const redirectToEntries = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.ATHLETE_CONTACTS, { state: { tryGet: true } });
    }
    else {
      //Meet Route
      navigate(NavLinks.ATHLETE_CONTACTS, { state: { tryGet: true } });
    }
  }

  useEffect(() => {
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    redirectToPurchases,
    redirectToEntries,
    orgUnitAthleteEntryId: omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId
  };
};

export default useAthleteUserPayments;